@if (activeNavigationItem.action == 'system') {

    <mvs-widget *ngIf="basicWidgetData" [widgetData]="basicWidgetData"></mvs-widget>
}

@if (activeNavigationItem.action == 'test') {
    <im-test-component
            *ngIf="objectIdentifier.objectId"
            [schemaFileId]="objectIdentifier.objectId"
    ></im-test-component>
}